import { price as priceUtil } from '@eti/utils';
import { Card } from '@etg/wings';
import type { OrderExtraProductType } from '../utils';
import PaymentItem from './PaymentItem';
import CarrierPriceList from './CarrierPriceList';

interface ExtraProductsProps {
  product: OrderExtraProductType;
  shouldShowCarrierPricesBreakdown: boolean;
}

const ExtraProducts = ({ product, shouldShowCarrierPricesBreakdown }: ExtraProductsProps) => {
  return shouldShowCarrierPricesBreakdown &&
    product.providerPricePerCarrier &&
    product.providerPricePerCarrier.length > 0 ? (
    <Card.Section
      data-testid={`providerPrice-per-carrier-extraProduct-${product.id}`}
      key={`providerPrice-per-carrier-extraProduct-${product.id}`}
    >
      <CarrierPriceList
        amountType="providerPrice"
        carrierPrices={product.providerPricePerCarrier}
        dataTestId={`providerPrice-per-carrier-extraProduct-${product.id}`}
        heading={product.title}
        price={product.totalPrice}
      />
    </Card.Section>
  ) : (
    <PaymentItem
      dataTestId={`priceSpecification-extraProduct-${product.title}`}
      key={`priceSpecification-extraProduct-${product.title}`}
      price={priceUtil.formatPrice(product.totalPrice)}
      title={product.title}
    />
  );
};

export default ExtraProducts;
